module.exports = __webpack_public_path__ + "static/img/a7070xgri_pop8.1859402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/images/a7070xgri_pop8.jpg
// module id = IDoH
// module chunks = 0